import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../shared/services/global.service';
import { LocaleService } from '../../shared/services/locale.service';
import { ModalService } from '../../shared/services/modal.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { UserService } from '../../shared/services/user.service';
import { DomainService } from '../../shared/services/domain.service';
import { RoleTypes } from '../../guards/roletypes';

@Component({
  selector: 'app-admin-menu-header',
  templateUrl: './admin-menu-header.component.html',
  styleUrls: ['./admin-menu-header.component.scss'],
  standalone: false,
})
export class AdminMenuHeaderComponent implements OnInit {
  loggedIn = false;
  isNavbarCollapsed = true;
  RoleTypes = RoleTypes;

  private subscriptionUser: Subscription;

  currentLanguage = this.localeService.currentLanguage;
  supportedLanguages = this.localeService.supportedLanguages;

  /**
   * Constructor
   *
   * @param global
   * @param localeService
   * @param modalService
   * @param authService
   */
  constructor(
    public global: GlobalService,
    public localeService: LocaleService,
    public modalService: ModalService,
    public authService: AuthenticationService,
    public userService: UserService,
    public domain: DomainService
  ) {
    this.subscriptionUser = new Subscription();
  }

  /**
   * Ng on init
   */
  ngOnInit(): void {
    // Check if a user is authenticated and set loggedIn state
    this.authService.isAuthenticated$.subscribe((authenticated) => {
      this.loggedIn = authenticated;
    });
  }

  Logout() {
    this.authService.Logout();
  }

  ngOnDestroy() {
    this.subscriptionUser.unsubscribe();
  }
}
